import {PrintDocumentsService} from '@services/print-documents.service';
import * as moment from 'moment';
import {FontAwesomeService} from '@services/font-awesome.service';
import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {PackageDetailsService} from '@services/package-details.service';
import {TotalPackageData} from '@models/total-package-data.interface';
import {AccountService} from '@services/account.service';
import {ModalDataSet} from '@store/actions/modal.action';
import {Store} from '@ngrx/store';
import {AppState, selectUser} from '@store/reducers';
import {PrintFormatEnum} from '@models/print.enum';
import {environment} from '../../../../environments/environment';
import {takeUntil} from 'rxjs/operators';
import {User} from '@models/user.interface';
import {Subject} from 'rxjs/Subject';
import {TranslateService} from '@ngx-translate/core';
import {SavedShipment} from '@models/saved-shipment.interface';
import {UUID} from 'angular2-uuid';
import {UpdateSavedShipment} from '@store/actions';
import {Router} from '@angular/router';
import 'rxjs/add/operator/map';
import {DateFormatPipe} from '@pipes/date-format.pipe';
import {CustomsDataDocumentTypeEnum} from '@models/customs-data-document-type-enum';

@Component({
  selector: 'app-order-info',
  templateUrl: './order-info.component.html',
  styleUrls: ['./order-info.component.scss']
})

export class OrderInfoComponent implements OnInit, OnDestroy {
  @Input() order: any;
  @Input() shipment: any;
  @Input() failure = false;
  @Input() index = 1;
  @Input() orderId: number;
  @Input() showCircle = true;
  // @Input() price: number;
  // @Input() addon: number;
  // @Input() vat: number;
  // @Input() total: number;

  @Input() shipmentCost: {amount: number, vat: number};
  @Input() surchargesCost: {amount: number, vat: number};
  @Input() additionalServicesCost: {amount: number, vat: number};
  @Input() oldAddonsCost: {amount: number, vat: number};
  @Input() oldExtraChargesCost: {amount: number, vat: number};
  @Input() totalCost: {amount: number, vat: number};

  public returnShipmentButtonDisabled = false;
  public duplicateShipmentButtonDisabled = false;

  public hasWaybill = false;
  private user: User;
  private userPrintSetting;
  private userPrintFormat;
  private unsubscribe: Subject<void> = new Subject();
  public currentLanguage: string;

  constructor(
    private router: Router,
    public faService: FontAwesomeService,
    public printDocuments: PrintDocumentsService,
    private packageDetailsService: PackageDetailsService,
    private accountService: AccountService,
    private store: Store<AppState>,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.currentLanguage = this.translate.currentLang;
    this.store.select(selectUser)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data: User) => {
        this.user = data;
        if (data) {
          this.userPrintSetting = data.settings.unifaun_print_settings;
          this.userPrintFormat = data.settings.unifaun_print_format;
        }
      });
    this.hasWaybill = environment.Unifaun.waybillProducts.includes(this.shipment.product_id);
  }

  print(type) {
    this.printDocuments.printFreightDocsByConsignmentNumber(this.shipment.shipment_ref, type, this.userPrintFormat, this.userPrintSetting);
  }

  printOrderReceipt() {
    this.printDocuments.printOrderReceipt(this.order.id);
  }

  // TODO: Fix receipt printing...???
  printReceipts() {
    /*
    this.accountService.getOrderDocuments(this.orderId)
      .subscribe(documents => {
        const receipt = documents.find(({type}) => type === 'receipt');
        if (!receipt) {
          this.store.dispatch(new ModalDataSet(
            {
              bodyModalText: 'Unfortunately, any receipt was found',
              removeShow: false,
              showCancel: false,
              showOk: true
            }));
          return;
        }
        this.printDocuments.printDocument(receipt.link, this.orderId);
      });
     */
  }

  get totalPackageData (): TotalPackageData {
    const {quantity, volume, weight, type, stackable, stackableText} = this.shipment.packages;
    if (quantity && type && weight) {
      return {quantity, type, weight, volume, stackable, stackableText};
    }
    const data = this.packageDetailsService.getTotalPackagesData(this.shipment.packages, false);
    return {
      quantity: data.quantity,
      volume: data.volume,
      weight: data.weight,
      type: data.type,
      stackable: data.stackable,
      stackableText: data.stackable === 1 ?
        this.translate.instant('common.consignment.stackable') :
        this.translate.instant('common.consignment.notStackable')
    };
  }

  get deliveryTime() {
    return this.shipment.delivery_time_to && this.shipment.delivery_time_to.slice(0, 5);
  }

  get pickupTime() {
    let time = this.shipment.pickup_time_to && this.shipment.pickup_time_to.slice(0, 5);
    if (this.shipment.product.code === 'DHLServicePointC2B' || this.shipment.product.code === 'DHLParcelReturnConnect') {
      time = '';
    }
    return time;
  }

  get deliveryDate() {
    let date = `${(new DateFormatPipe(
      this.translate)).transform(
      this.shipment.delivery_date, 'mediumDate', '', this.translate.currentLang
    )}`;

    if (this.shipment.product.code === 'DHLServicePointC2B' || this.shipment.product.code === 'DHLParcelReturnConnect') {
      date = this.translate.instant('common.consignment.deliveryType.1');
    }

    return date;
  }

  get pickupDate() {
    let date = `${(new DateFormatPipe(
      this.translate)).transform(
        this.shipment.pickup_date, 'mediumDate', '', this.translate.currentLang
    )}`;

    if (this.shipment.product.code === 'DHLServicePointC2B' || this.shipment.product.code === 'DHLParcelReturnConnect') {
      date = this.translate.instant('common.consignment.pickupType.2') + ' ' + this.translate.instant('common.consignment.pickupType.timespan');
    }

    return date;
  }

  createReturnShipment() {
    this.returnShipmentButtonDisabled = true;
    const parts = {
      consignor: {
        type: <string> '',
        address: <string> '',
        zip: <string> '',
        city: <string> '',
        country: '',
        country_code: '',
        company: <number> 0,
        company_name: <string> '',
        name: <string> '',
        surname: <string> '',
        phone: <string> '',
        email: <string> '',
        instructions: <string> '',
        door_code: <string> ''
      },
      consignee: {
        type: <string> '',
        address: <string> '',
        zip: <string> '',
        city: <string> '',
        country: '',
        country_code: '',
        company: <number> 0,
        company_name: <string> '',
        name: <string> '',
        surname: <string> '',
        phone: <string> '',
        email: <string> '',
        instructions: <string> '',
        door_code: <string> ''
      },
      pickup: null,
      delivery: null
    };
    let productId = this.shipment.product_id;
    let reference = '';

    if (this.shipment.reference) {
      reference = this.shipment.reference + ' - ' + this.translate.instant('common.consignment.createReturnShipmentTitle');
    } else if (this.shipment.shipment_ref) {
      reference = this.shipment.shipment_ref + ' - ' + this.translate.instant('common.consignment.createReturnShipmentTitle');
    } else {
      reference = this.translate.instant('common.consignment.createReturnShipmentTitle');
    }

    if (this.shipment.product.code === 'DHLServicePointB2C') {
      productId = 11;
    } else if (this.shipment.product.code === 'DHLHomeDelivery') {
      productId = 51;
    } else if (this.shipment.product.code === 'DHLEuroConnect') {
      productId = 47;
    } else if (this.shipment.product.code === 'DHLParcelConnectPlus'  || this.shipment.product.code === 'DHLParcelConnect') {
      productId = null;
    }

    if (this.shipment.product.code === 'DHLServicePointB2C' || this.shipment.product.code === 'DHLParcelConnect') {
      // Service point retur, switch original consignor and consignee.
      // Switch pickup and delivery if present.
      parts.consignor = this.shipment.consignee;
      parts.consignee = this.shipment.pickup ? this.shipment.pickup : this.shipment.consignor;
      parts.pickup = null;
      parts.delivery = null;
    } else if (this.shipment.product.code === 'DHLHomeDelivery') {
      // Home Delivery Retur, switch original consignor and consignee.
      // Home Delivery, delivery part not available.
      // Home Delivery Retur, pickup part not available.
      parts.consignor = this.shipment.consignee;
      parts.consignee = this.shipment.consignor;
      parts.pickup = null;
      parts.delivery = this.shipment.pickup ? this.shipment.pickup : null;
    } else {
      // All other products, Use consignor as both consignor and consignee
      // Create pickup from consignee if delivery not present.
      // Switch pickup and delivery if present.
      parts.consignor = this.shipment.consignor;
      parts.consignee = this.shipment.consignor;
      parts.pickup = this.shipment.delivery ? this.shipment.delivery : this.shipment.consignee;
      parts.delivery = this.shipment.pickup ? this.shipment.pickup : null;
    }

    parts.consignor.type = parts.consignor.company === 1 ? 'company' : 'private';
    parts.consignee.type = parts.consignee.company === 1 ? 'company' : 'private';

    if (parts.pickup !== null) {
      parts.pickup.is_used = true;
      parts.pickup.type = parts.pickup.company === 1 ? 'company' : 'private';
    }

    if (parts.delivery !== null) {
      parts.delivery.is_used = true;
      parts.delivery.type = parts.delivery.company === 1 ? 'company' : 'private';
    }

    const data: SavedShipment = {
      from: parts.consignor,
      to: parts.consignee,
      pickup: parts.pickup,
      delivery: parts.delivery,
      packages: this.shipment.packages.map(item => {
        const {type, stackable, quantity, length, width, height, weight} = item;
        return {
          type: type,
          stackable: stackable,
          quantity: quantity,
          length: length,
          width: width,
          height: height,
          weight: weight
        };
      }),
      reference: reference,
      parcel_value: this.shipment.parcel_value,
      parcel_content: this.shipment.parcel_content,
      daily_pickup: false,
      pickup_date: moment().format('YYYY-MM-DD'),
      pickup_time: '16:00',
      title: UUID.UUID(),
      product_id: productId,
      filters: [],
      referring_consignment_number: this.shipment.shipment_ref
    };

    if (this.shipment.is_dutiable) {
      data.customs_data = {
        document_type: CustomsDataDocumentTypeEnum.PROFORMA,
        invoice_number: this.shipment.customs_data.invoice_number,
        invoice_date: this.shipment.customs_data.invoice_date,
        statistical_number: this.shipment.customs_data.items[0].statistical_number,
        total_declared_value: this.shipment.customs_data.total_declared_value,
        currency: this.shipment.customs_data.currency
      };
    }

    this.store.dispatch(new UpdateSavedShipment(data));

    setTimeout(() => {
      this.router.navigate(['shipments', 'saved']);
    }, 1000);
  }

  createDuplicateShipment() {
    this.duplicateShipmentButtonDisabled = true;

    let reference = '';

    if (this.shipment.reference) {
      reference = this.shipment.reference + ' - ' + this.translate.instant('common.consignment.copyShipmentTitle');
    } else if (this.shipment.shipment_ref) {
      reference = this.shipment.shipment_ref + ' - ' + this.translate.instant('common.consignment.copyShipmentTitle');
    } else {
      reference = this.translate.instant('common.consignment.copyShipmentTitle');
    }

    const data: SavedShipment = {
      // from: this.shipment.to,
      from: {
        type: this.shipment.from.company === 1 ? 'company' : 'private',
        address: this.shipment.from.address,
        zip: this.shipment.from.zip,
        city: this.shipment.from.city,
        country: this.shipment.from.country,
        country_code: this.shipment.from.country_code,
        company_name: this.shipment.from.company_name,
        name: this.shipment.from.name,
        surname: this.shipment.from.surname,
        phone: this.shipment.from.phone,
        email: this.shipment.from.email,
        instructions: this.shipment.from.instructions,
        door_code: this.shipment.from.door_code
      },
      // to: this.shipment.from,
      to: {
        type: this.shipment.to.company === 1 ? 'company' : 'private',
        address: this.shipment.to.address,
        zip: this.shipment.to.zip,
        city: this.shipment.to.city,
        country: this.shipment.to.country,
        country_code: this.shipment.to.country_code,
        company_name: this.shipment.to.company_name,
        name: this.shipment.to.name,
        surname: this.shipment.to.surname,
        phone: this.shipment.to.phone,
        email: this.shipment.to.email,
        instructions: this.shipment.to.instructions,
        door_code: this.shipment.to.door_code,
        send_tracking_information: !!this.shipment.send_tracking_information
      },
      packages: this.shipment.packages.map(item => {
        const {type, stackable, quantity, length, width, height, weight} = item;
        return {
          type: type,
          stackable: stackable,
          quantity: quantity,
          length: length,
          width: width,
          height: height,
          weight: weight
        };
      }),
      reference: reference,
      parcel_value: this.shipment.parcel_value,
      parcel_content: this.shipment.parcel_content,
      daily_pickup: this.shipment.daily_pickup ? this.shipment.daily_pickup : false,
      pickup_date: moment().format('YYYY-MM-DD'),
      pickup_time: '16:00',
      title: UUID.UUID(),
      product_id: null,
      filters: [],
      referring_consignment_number: this.shipment.referring_consignment_number
    };

    if (this.shipment.pickup) {
      data.pickup = {
        type: this.shipment.pickup.company === 1 ? 'company' : 'private',
          is_used: true,
          address: this.shipment.pickup.address,
          zip: this.shipment.pickup.zip,
          city: this.shipment.pickup.city,
          country: this.shipment.pickup.country,
          country_code: this.shipment.pickup.country_code,
          company_name: this.shipment.pickup.company_name,
          name: this.shipment.pickup.name,
          surname: this.shipment.pickup.surname,
          phone: this.shipment.pickup.phone,
          email: this.shipment.pickup.email,
          instructions: this.shipment.pickup.instructions,
          door_code: this.shipment.pickup.door_code
      };
    }

    if (this.shipment.delivery) {
      data.delivery = {
        is_used: true,
        type: this.shipment.delivery.company === 1 ? 'company' : 'private',
        address: this.shipment.delivery.address,
        zip: this.shipment.delivery.zip,
        city: this.shipment.delivery.city,
        country: this.shipment.delivery.country,
        country_code: this.shipment.delivery.country_code,
        company_name: this.shipment.delivery.company_name,
        name: this.shipment.delivery.name,
        surname: this.shipment.delivery.surname,
        phone: this.shipment.delivery.phone,
        email: this.shipment.delivery.email,
        instructions: this.shipment.delivery.instructions,
        door_code: this.shipment.delivery.door_code
      };
    }

    if (this.shipment.is_dutiable) {
      data.customs_data = {
        document_type: CustomsDataDocumentTypeEnum.PROFORMA,
        invoice_number: this.shipment.customs_data.invoice_number,
        invoice_date: this.shipment.customs_data.invoice_date,
        statistical_number: this.shipment.customs_data.items[0].statistical_number,
        total_declared_value: this.shipment.customs_data.total_declared_value,
        currency: this.shipment.customs_data.currency
      };
    }

    this.store.dispatch(new UpdateSavedShipment(data));

    setTimeout(() => {
      this.router.navigate(['shipments', 'saved']);
    }, 500);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/atoms/order-info/order-info.component.ts